import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4 4.5V11.5C4 13.1569 5.34315 14.5 7 14.5H15C16.6569 14.5 18 13.1569 18 11.5V5.5C18 4.94772 17.5523 4.5 17 4.5H4Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4 6.5V4.5C4 3.39543 3.10457 2.5 2 2.5H1",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "15.75",
      cy: "17.5",
      r: "1.25",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "6.25",
      cy: "17.5",
      r: "1.25",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }